// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1664) return "static/chunks/1664-cfacfdc7010dff71.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"999":"7b427114c29e67f1","1453":"61faaacaefa098d8","2246":"a440b2b6ae1fd9fd","4238":"edf8a53baeb2c8d3","5420":"1c388fca908ce4a1","8148":"627f7940bf76c2b7"}[chunkId] + ".js";
};